import { Component, Input, OnInit, OnDestroy, HostListener, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { Subject, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


import { UserService } from '../../../services/user.service';

interface MenuItem {
    icon: string;
    label: string;
    link: string;
}

@Component({
    selector: 'app-time-stamp-menu',
    templateUrl: './time_stamp_menu.component.html',
    styleUrls: ['./time_stamp_menu.component.css']
})
export class TimeStampMenuComponent implements OnInit, OnDestroy, AfterViewInit  {
    @Input() InputDate: Date;  // Input property to receive username    menuItems: MenuItem[];  // Array to hold menu items
    @ViewChild('profileLink', { static: false }) profileLinkElement: ElementRef;
    @ViewChild('tooltip', { static: false }) tooltipElement!: ElementRef;

    menuItems: MenuItem[];  // Array to hold menu items

    userProfileStates = new Map<number, any>();

    showProfileBox: boolean = false;
    showTooltip: boolean = false;

    isFollowed: boolean = false; // Follow status will be fetched dynamically

    userProfileVisible = false;
    hoverBoxStyle = {};
    userProfile: any;

    private unsubscribeHover$ = new Subject<void>();

    private observer: IntersectionObserver;
    hoverTimer: any; // To hold the timer reference
    private timeoutId: any; // Holds the reference to the timeout



    constructor(
        private userService: UserService,
    ) {
        // Define menu items - this could instead be loaded from a service
        this.menuItems = [
            { icon: 'fa-house', label: 'Home', link: '/' },
            { icon: 'fa-compass', label: 'Explore', link: '/explore' },
            { icon: 'fa-bell', label: 'Notifications', link: '/notifications' },
            // Add more items as needed
        ];
    }

    ngOnInit(): void {
        // Additional initialization can be done here
    //    this.fetchFollowStatus();
    }

    ngAfterViewInit(): void {
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                //    this.loadUserProfileData(false);
                }
            });
        });

        if (this.profileLinkElement) {
            this.observer.observe(this.profileLinkElement.nativeElement);
        }
    }

    ngOnDestroy(): void {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId); // Clear timeout on component destruction
        }
        if (this.hoverTimer) {
            clearTimeout(this.hoverTimer); // Clear the timer if the mouse leaves the link
        }
        this.showProfileBox = false;
        this.showTooltip = false;
        // Clear the timeoutId after it executes
        this.timeoutId = null;
        this.hoverTimer = null;
        if (this.observer && this.profileLinkElement) {
            this.observer.unobserve(this.profileLinkElement.nativeElement);
        }
    }

    @HostListener('window:scroll', ['$event'])
    onScroll(): void {
        this.showProfileBox = false;
        this.showTooltip = false;
        // Clear the timeoutId after it executes
        this.timeoutId = null;
        this.hoverTimer = null;
    }

    showTimeDetailHover_prev(event: MouseEvent) {
        //console.log(`Mouse over loadUserProfile`);

        event.stopPropagation(); // Add this to prevent event bubbling

        // Check the class of the event target to determine which functionality to trigger
        const target = event.target as HTMLElement;
        //console.log('Hovered element:', target); // Debugging output

        //if (target.classList.contains('publish-date')) {

        // Check if the hovered element or its parent has the 'publish-date' class
        const parentWithClass = target.closest('.publish-date');
        if (parentWithClass) {

            // Logic for showing the date tooltip
            this.hoverTimer = setTimeout(() => {
                this.showTooltip = true;

                if (this.hoverTimer) clearTimeout(this.hoverTimer);

                this.showProfileBox = false;
            }, 1000);  // Delay in milliseconds
        } 
    }

    showTimeDetailHover(event: MouseEvent) {
        event.stopPropagation(); // Prevent event bubbling

        const target = event.target as HTMLElement;
        const parentWithClass = target.closest('.publish-date') as HTMLElement;

        this.hoverTimer = setTimeout(() => {
            this.showTooltip = true;

            setTimeout(() => {
                const tooltipNativeElement = this.tooltipElement?.nativeElement;
                console.log('Tooltip:', tooltipNativeElement);

                if (tooltipNativeElement) {
                    const rect = parentWithClass.getBoundingClientRect();
                    const tooltipHeight = tooltipNativeElement.offsetHeight;

                    const spaceBelow = window.innerHeight - rect.bottom;
                    // Position the tooltip based on space availability
                    //const topPosition = spaceBelow < tooltipHeight
                    //    //? rect.top - tooltipHeight - 10 // Above the element
                    //    ? - 10 // Above the element
                    //    : rect.bottom + 10; // Below the element

                    //const leftPosition = rect.left; // Align horizontally with the element

                    // Set tooltip position dynamically
                    //this.hoverBoxStyle = {
                    //    position: 'absolute',
                    //    top: `${topPosition}px`,
                    ////    left: `${leftPosition}px`,
                    //};



                    //const hoverBoxHeight = 50;  // Fixed height or dynamically determined

                    if (spaceBelow < tooltipHeight) {
                        this.hoverBoxStyle = { top: '-10px' };
                    }
                    //else {
                    //    this.hoverBoxStyle = { top: '30px' };
                    //}

                //    const tooltipHeight = tooltipNativeElement.offsetHeight;
                //    const tooltipWidth = tooltipNativeElement.offsetWidth;
                //    const windowHeight = window.innerHeight;
                //    const windowWidth = window.innerWidth;

                //    const shouldShowAbove = rect.bottom + tooltipHeight > windowHeight;
                //    const shouldAlignLeft = rect.left + tooltipWidth > windowWidth;

                //    tooltipNativeElement.style.position = 'absolute';
                //    tooltipNativeElement.style.top = shouldShowAbove
                //        ? `${rect.top - tooltipHeight}px`
                //        : `${rect.bottom}px`;
                //    tooltipNativeElement.style.left = shouldAlignLeft
                //        ? `${rect.left - (tooltipWidth - rect.width)}px`
                //        : `${rect.left}px`;
                //    tooltipNativeElement.style.display = 'block';
                }
            });
        }, 1000); // Delay in milliseconds

    }

    loadUserProfile(event: MouseEvent) {
        //console.log(`Mouse over loadUserProfile`);

        event.stopPropagation(); // Add this to prevent event bubbling

        // Check the class of the event target to determine which functionality to trigger
        const target = event.target as HTMLElement;
        if (target.classList.contains('publish-date')) {
            // Logic for showing the date tooltip
            this.hoverTimer = setTimeout(() => {
                this.showTooltip = true;

                if (this.hoverTimer) clearTimeout(this.hoverTimer);

                this.showProfileBox = false;
            }, 2000);  // Delay in milliseconds
        } else {
            this.hoverTimer = setTimeout(() => {

            }, 2000); // Delay of 1000 milliseconds (1 second)
        }
    }

    keepHoverBoxVisible(): void {
        //this.unsubscribeHover$.next();
        if (this.timeoutId) {
            clearTimeout(this.timeoutId); // Cancel the pending timeout
            this.timeoutId = null;
        }
        this.showProfileBox = true;
    }

    hideUserProfile() {
        if (this.timeoutId) clearTimeout(this.timeoutId);
        if (this.hoverTimer) clearTimeout(this.hoverTimer);

        // Set a new timeout
        this.timeoutId = setTimeout(() => {
            //clearTimeout(this.hoverTimer); // Clear the timer if the mouse leaves the link
            this.showProfileBox = false;
            this.showTooltip = false;
            // Clear the timeoutId after it executes
            this.timeoutId = null;
        }, 2000); // Delay in milliseconds
    }

    mouseleaveHandler(event: MouseEvent) {
        clearTimeout(this.hoverTimer);
        setTimeout(() => {
            this.showTooltip = false;
            const tooltipElements = document.querySelectorAll('.tooltip') as NodeListOf<HTMLElement>;
            tooltipElements.forEach((tooltip) => (tooltip.style.display = 'none'));
        }, 500); // Delay before hiding the tooltip
    }

    adjustHoverBoxPosition(): void {
        if (this.profileLinkElement && this.profileLinkElement.nativeElement) {
            const rect = this.profileLinkElement.nativeElement.getBoundingClientRect();
            const spaceBelow = window.innerHeight - rect.bottom;
            const hoverBoxHeight = 200;  // Fixed height or dynamically determined

            if (spaceBelow < hoverBoxHeight) {
                this.hoverBoxStyle = { bottom: '30px' };
            } else {
                this.hoverBoxStyle = { top: '30px' };
            }
        }
    }

}
